import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';
const screenfull = require('screenfull');

import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { Repository } from '../../services/repository'
@Component({
    selector: 'app-headerh',
    templateUrl: './header.component.h.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderHComponent implements OnInit {
  tendonvi: string = null;
  dschinhanhs: any = [];
  ngon_ngu: any = 1;
    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    router: Router;
  username: string;
  giang_vien: string;
    isNavSearchVisible: boolean;
    @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button

  constructor(public menu: MenuService, public userblockService: UserblockService, public settings: SettingsService, public injector: Injector, public repo: Repository) {

        // show only a few items on demo
      this.menuItems = menu.getMenu().slice(-3); // for horizontal layout
      var currentUser1 = localStorage.getItem('currentUser');
      let data = JSON.parse(currentUser1);
     
      if (data != null) {
        this.username = data.user_name;
        this.giang_vien = data.giang_vien;
    }

    this.ngon_ngu = JSON.parse(localStorage.getItem('ngon_ngu'));
    if (this.ngon_ngu == null)
      this.ngon_ngu = "1";

    this.repo.postRequest('api/login/gettrungtams', { UserName: this.username})
      .subscribe(response => {
        this.dschinhanhs = response;
      });

  }
  changechinhanh(row) {
    this.tendonvi = row.Ten;

    this.repo.getRequest('api/Login/doichinhanh/' + row.Id)
      .subscribe(response => {

        var currentUser1 = localStorage.getItem('currentUser');
        let data = JSON.parse(currentUser1);
        data.id_don_vi = row.Id;
        data.ten_don_vi = row.Ten;
        localStorage.setItem('currentUser', JSON.stringify(data));
        window.location.reload();
      });
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    ngOnInit() {
        this.isNavSearchVisible = false;

        var ua = window.navigator.userAgent;
        if (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }

       

        this.router = this.injector.get(Router);

        // Autoclose navbar on mobile when route change
        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close collapse menu
            this.navCollapsed = true;
        });

    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
  }
  ChonNgonNgu(id: any) {
    this.ngon_ngu = id;
    if (this.username) {
      let data1 = {
        Id: null,
        Type: null,
        Data: JSON.stringify({ NgonNgu: id, UserName: this.username })
      };
      this.repo.postRequest("api/donvi/CapNhatUser/", data1)
        .subscribe(response => {
          let tttdata = JSON.parse(localStorage.getItem('currentUser'));
          tttdata.ngon_ngu = id;
          localStorage.setItem('currentUser', JSON.stringify(tttdata));
          localStorage.setItem('ngon_ngu', id);

          this.repo.getRequest("api/login/getdsngongu/", { ngonnguid: id })
            .subscribe(response => {
              localStorage.setItem('NgonNgus', JSON.stringify(response.dsngonngu));
            });
          if (tttdata.giang_vien == "2")
            location.href = '/home';
          else 
            location.href = '/#/dashboard';

        });


    }
    else {
      this.repo.getRequest("api/login/getdsngongu/", { ngonnguid: id })
        .subscribe(response => {
          localStorage.setItem('NgonNgus', JSON.stringify(response.dsngonngu));
          localStorage.setItem('ngon_ngu', id);
          location.href = '/home';
        });

    }


  }

  logout() {

    console.log("Xoa cookie trên Angular")
    localStorage.removeItem('currentUser');
    location.href = '/Home/Logout';
    //this.authenticationService.logout();

    //this.router.navigate(['/home']);
  }
}
